import React from 'react';
import { Watch } from 'lucide-react';
import ModalCloseButton from '../Modals/ModalCloseButton';

export default function PairWatchModal({ isOpen, onClose, pairingCode }) {
  if (!isOpen) return null;

  const formattedCode = pairingCode
    ? `${pairingCode.slice(0, 3)} ${pairingCode.slice(3)}`
    : '839 201';

  return (
    <div
      onClick={onClose}
      className="modal-overlay"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="modal pair-watch-modal"
      >
        <ModalCloseButton onClick={onClose} />

        {/* Header Icon & Title */}
        <div className="flex flex-col items-center text-center mb-4 sm:mb-6 landscape:mb-3 pt-1">
          <Watch className="w-8 h-8 sm:w-10 sm:h-10 landscape:w-7 landscape:h-7 text-slate-100 mb-2 landscape:mb-1" />
          <h2 className="modal-title" style={{ margin: 0 }}>
            Pair Smartwatch
          </h2>
        </div>

        {/* Pairing Code Display */}
        <div className="bg-slate-900/90 border border-slate-700/80 rounded-2xl p-4 sm:p-5 landscape:py-2.5 mb-4 sm:mb-6 landscape:mb-3 text-center shadow-inner">
          <div className="font-nunito-black-italic text-5xl sm:text-6xl landscape:text-5xl text-[#f5b83d] tracking-widest drop-shadow-[0_4px_12px_rgba(245,184,61,0.5)] my-0.5 sm:my-1">
            {formattedCode}
          </div>
        </div>

        {/* 2-Step Guide */}
        <div className="space-y-2.5 sm:space-y-3 mb-4 sm:mb-6 landscape:mb-3 text-xs sm:text-sm text-slate-300">
          <div className="flex items-center gap-3 bg-slate-800/50 p-2.5 sm:p-3 landscape:py-2 landscape:px-3 rounded-xl border border-slate-700/40">
            <span className="font-black text-[#f5b83d] bg-slate-900 w-5 h-5 rounded-full flex items-center justify-center text-[11px] flex-shrink-0">1</span>
            <span className="leading-snug">Open the <strong>Padel MVP</strong> app on your Apple Watch or Wear OS watch.</span>
          </div>
          <div className="flex items-center gap-3 bg-slate-800/50 p-2.5 sm:p-3 landscape:py-2 landscape:px-3 rounded-xl border border-slate-700/40">
            <span className="font-black text-[#f5b83d] bg-slate-900 w-5 h-5 rounded-full flex items-center justify-center text-[11px] flex-shrink-0">2</span>
            <span className="leading-snug">Tap <strong>Join Match</strong> and enter the 6-digit pairing code above.</span>
          </div>
        </div>

        {/* Dismiss Button */}
        <button type="button" onClick={onClose} className="btn btn-primary btn-full">
          <span className="btn-text">Done</span>
        </button>

      </div>
    </div>
  );
}
